/**
 * The place a sign-in returns to (GRO-115, R4-F2). The Google callback always redirects to
 * `/`, so a destination that must survive sign-in is carried here, client side, and only
 * selects which branch of the boundary runs: the backend still authorizes every request.
 * Every storage access is wrapped, and without storage the sign-in lands on `/` as before.
 */
import { isAdminPath } from '../admin/sections'

const KEY = 'grovus.signInReturn'
const allowed = (pathname: string) => isAdminPath(pathname) || pathname === '/invite'

/**
 * Called as sign-in starts. Stores an allowed pathname; on `/sign-in` keeps what is stored,
 * so a retry after a callback error still returns there; anywhere else clears it.
 */
export function rememberSignInReturn(pathname: string) {
  try {
    if (allowed(pathname)) sessionStorage.setItem(KEY, pathname)
    else if (pathname !== '/sign-in') sessionStorage.removeItem(KEY)
  } catch {
    // No storage: the sign-in returns to `/`.
  }
}

/** Reads the stored destination once and removes it; null unless it is allowed. */
export function takeSignInReturn(): string | null {
  try {
    const value = sessionStorage.getItem(KEY)
    sessionStorage.removeItem(KEY)
    return value !== null && allowed(value) ? value : null
  } catch {
    return null
  }
}
